import type { OptionsDocument } from 'paintscout'
import type { EventTypeOption } from '..'

export function reorderEventTypes(args: { options: OptionsDocument; eventTypes: EventTypeOption[] }): OptionsDocument {
  const { options, eventTypes } = args
  return {
    ...options,
    options: {
      ...options.options,
      eventTypes: {
        ...options.options.eventTypes,
        order: eventTypes.map((item: EventTypeOption) => item.key)
      }
    }
  }
}
